/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { NgClass } from "@angular/common";
import { Component } from "@angular/core";
import { INoRowsOverlayAngularComp } from "ag-grid-angular";

@Component({
	selector: "globalictcc-no-rows-overlay",
	standalone: true,
	imports: [NgClass],
	templateUrl: "./no-rows-overlay.component.html",
	styleUrl: "./no-rows-overlay.component.scss"
})
export class NoRowsOverlayComponent implements INoRowsOverlayAngularComp {
	public agInit() {}
}
